/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint object-curly-newline: ["error", { "multiline": true }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import lodash from 'lodash';
import axios from 'axios';
import qs from 'qs';

// initial state
const state = {
  documents: null,
  downloadInProgress: false,
  activeSection: 'member_documents',
  pricingVendors: [],
  edgeDocuments: [],
  resourceGuides: [],
  contracts: [],
  loaders: {
    vendors: false,
    documents: false,
    library: false,
    resourceGuides: false,
  },
  initializers: {
    vendors: false,
    documents: false,
    library: false,
    resourceGuides: false,
  },
};

// getters
const getters = {
  activeSection: (state) => state.activeSection,
  pricingVendors: (state) => lodash.reject(
    state.pricingVendors,
    (vendor) => vendor.name === 'Phonak' || vendor.name === 'Unitron'
  ),
  // nonPricingVendors: (state) => state.nonPricingVendors,
  // featuredVendors: (state) => state.featuredVendors,
  contracts: (state) => state.contracts,
  edgeDocuments: (state) => state.edgeDocuments,
  documents: (state) => state.documents,
  resourceGuides: (state) => state.resourceGuides,
  downloadInProgress: (state) => state.downloadInProgress,
  member_id: (state, getters, rootState, rootGetters) => rootGetters['main/member_id'],
  member_name: (state, getters, rootState, rootGetters) => lodash.kebabCase(rootGetters['main/memberName']),
  loaders: (state) => state.loaders,
  initializers: (state) => state.initializers,
  token: (state, getters, rootState, rootGetters) => rootGetters['auth/user']['token'],
  downloadPricingGetURL(vendor, templateId) {
    let url = `${CONFIG.get('BASE_URL')}/api/member/${this.member_id}/info/downloadPricingGuide/?`;
    url += `&vendor=${vendor}`;
    url += `&template_id=${templateId}`;
    return url;
  },
};

// actions
const actions = {
  getDocuments({ commit }) {
    commit('TOGGLE_LOADING', { key: 'documents', value: true });
    return axios.get(`${CONFIG.get('BASE_URL')}/api/documents/`)
      .then(({ data }) => {
        commit('SET_PROPERTY', { key: 'contracts', value: data.contracts });
        commit('SET_PROPERTY', { key: 'edgeDocuments', value: data.edgeDocuments });
        commit('TOGGLE_LOADING', { key: 'documents', value: false });
        commit('TOGGLE_INITIALIZED', { key: 'documents', value: true });
      });
  },
  getResourceGuides({ commit }) {
    commit('TOGGLE_LOADING', { key: 'resourceGuides', value: true });
    return axios.get(`${CONFIG.get('BASE_URL')}/api/documents/resourceGuides/`)
      .then(({ data }) => {
        commit('SET_PROPERTY', { key: 'resourceGuides', value: data.resources });
        commit('TOGGLE_LOADING', { key: 'resourceGuides', value: false });
        commit('TOGGLE_INITIALIZED', { key: 'resourceGuides', value: true });
      });
  },
  getVendors({ commit }) {
    commit('TOGGLE_LOADING', { key: 'vendors', value: true });
    return axios.get(`${CONFIG.get('BASE_URL')}/api/documents/vendors/`)
      .then(({ data }) => {
        commit('SET_PROPERTY', { key: 'pricingVendors', value: data.pricingVendors });
        commit('TOGGLE_LOADING', { key: 'vendors', value: false });
        commit('TOGGLE_INITIALIZED', { key: 'vendors', value: true });
      });
  },
  downloadPricing({ commit, getters }, vendor) {
    commit('SET_PROPERTY', { key: 'downloadInProgress', value: true });
    commit('TOGGLE_LOADING', { key: 'documents', value: true });
    axios.get(`${CONFIG.get('BASE_URL')}/api/member/${getters.member_id}/info/getPricingLink/?vendor=${vendor}`)
      .then(({ data }) => {
        if (data !== undefined && data !== -1) {
          window.location = `${CONFIG.get('BASE_URL')}/api/member/${getters.member_id}/info/downloadPricingGuide/?vendor=${vendor}&template_id=${data.template_id}&member_name=${getters.member_name}&bearer=${getters.token}`;
        }
        commit('SET_PROPERTY', { key: 'downloadInProgress', value: false });
        commit('TOGGLE_LOADING', { key: 'documents', value: false });
      });
  },
  setProperty({ commit }, payload) {
    commit('SET_PROPERTY', payload);
  },
};

// mutations
const mutations = {
  SET_PROPERTY(state, payload) {
    state[payload.key] = payload.value;
  },
  TOGGLE_LOADING(state, payload) {
    state.loaders[payload.key] = payload.value;
  },
  TOGGLE_INITIALIZED(state, payload) {
    state.initializers[payload.key] = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
